<template>
  <v-tabs left>
    <v-tab ripple> Policy Info </v-tab>
    <v-tab-item>
      <ri-Quick-Info></ri-Quick-Info>
    </v-tab-item>
    <v-tab ripple> Cedant Info </v-tab>
    <v-tab-item>
      <ri-cedant-info></ri-cedant-info>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import riQuickInfo from '@/components/core/underwriting/reinsurance/riQuickInfo'
import riCedantInfo from '@/components/core/underwriting/reinsurance/riCedantInfo'

export default {
  components: {
    riQuickInfo,
    riCedantInfo
  }
}
</script>

<style lang="scss" scoped>
</style>
